export enum PermissionStatus {
  ALLOW = 'allow',
  DENY = 'deny',
}
